import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-task",
  "use": "icon-task-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-task\"><defs><style></style></defs><path d=\"M512.3 63.4c-245.8 0-447 201.1-447 447s201.1 447 447 447 447-201.1 447-447-201.1-447-447-447zm0 804.6c-196.7 0-357.6-160.9-357.6-357.6s160.9-357.6 357.6-357.6 357.6 160.9 357.6 357.6S709 868 512.3 868z\" /><path d=\"M534.7 286.9h-67.1v268.2l232.5 143.1 35.7-58.2-201.1-120.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol